import styled from "styled-components";

export const StyledVueChanger = styled.div`
    display: flex;
    justify-content: space-between;
    width: calc(100% - 30px);
    position: fixed;
    top: 15px;
`;

export const StyledHead = styled.div`
    width: 100%;
    height: 48px;
    line-height: 48px;
    margin-bottom: 15px;
    font-size: 1.2rem;
    font-weight: 500;
    text-align: center;
`;

export const StyledTitle = styled.h2`
    margin: 0;
    font-size: 1.3rem;
`;



// WEBPACK FOOTER //
// ./src/ui/Styled.js